module.exports = __webpack_public_path__ + "img/srlogo-blue.74bd924d.png";